"use strict";
'kiwi public';

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _create = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/create"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _xhr = _interopRequireDefault(require("xhr"));

var _lodash = _interopRequireDefault(require("lodash"));

var _json = _interopRequireDefault(require("json5"));

var _Logger = _interopRequireDefault(require("./Logger"));

var log = _Logger.default.namespace('ConfigLoader');

var ConfigLoader = /*#__PURE__*/function () {
  function ConfigLoader() {
    (0, _classCallCheck2.default)(this, ConfigLoader);
    this.config = (0, _create.default)(null);
    this.valReplacements = (0, _create.default)(null);
  }

  (0, _createClass2.default)(ConfigLoader, [{
    key: "addValueReplacement",
    value: function addValueReplacement(key, value) {
      this.valReplacements[key] = value;
      return this;
    }
  }, {
    key: "loadFromUrl",
    value: function loadFromUrl(configUrl) {
      var _this = this;

      return new _promise.default(function (resolve, reject) {
        (0, _xhr.default)({
          url: configUrl
        }, function (err, response) {
          if (err) {
            reject();
            return;
          }

          var configObj = null;

          try {
            configObj = _json.default.parse(response.body);
          } catch (parseErr) {
            log.error('Config ' + parseErr.message);
            var errMsg = 'Config file error: ' + parseErr.message.replace('JSON5: ', ''); // Convert "at 22:16" to "at line 22, position 16"

            /* eslint-disable arrow-body-style */

            errMsg = errMsg.replace(/at (\d+):(\d+)/g, function (m, m1, m2) {
              var _context;

              return (0, _concat.default)(_context = "line ".concat(m1, ", position ")).call(_context, m2);
            });
            reject(errMsg);
            return;
          }

          _this.setConfig(configObj);

          resolve(_this.config);
        });
      });
    }
  }, {
    key: "loadFromObj",
    value: function loadFromObj(configObj) {
      var _this2 = this;

      return new _promise.default(function (resolve, reject) {
        _this2.setConfig(configObj);

        resolve(_this2.config);
      });
    }
  }, {
    key: "setConfig",
    value: function setConfig(confObj) {
      var _this3 = this;

      var walkObject = function walkObject(obj, target) {
        _lodash.default.each(obj, function (_val, key) {
          var val = _val;

          if (typeof val === 'string') {
            val = _this3.insertReplacements(val);
            target[key] = val;
          } else if ((0, _typeof2.default)(val) === 'object') {
            target[key] = _lodash.default.isArray(val) ? [] : {};
            walkObject(val, target[key]);
          } else {
            target[key] = val;
          }
        });
      };

      this.config = (0, _create.default)(null);
      walkObject(confObj, this.config);
    }
  }, {
    key: "insertReplacements",
    value: function insertReplacements(input) {
      var out = input;
      var keys = (0, _keys.default)(this.valReplacements);

      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];

        if (input === '{{' + k + '}}') {
          // If we have an exact match, return the exact replacement value we have as
          // it may not be a string
          return this.valReplacements[k];
        }

        out = out.replace('{{' + k + '}}', this.valReplacements[k]);
      }

      return out;
    }
  }]);
  return ConfigLoader;
}();

exports.default = ConfigLoader;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ConfigLoader"]
window._kiwi_exports.libs.ConfigLoader = exports.default ? exports.default : exports;
